/**
 * The confirm step of Skip this round (ISSUE-1044, SUR-R87). A plain confirm,
 * not a destructive one: a skip can be undone until the round locks. The
 * body states the skips left, so the fan knows what the tap spends.
 */
import { Button, Dialog } from "@sportsmet/ui";
import type { JSX } from "react";

import {
  SURVIVOR_SKIP_CANCEL_LABEL,
  SURVIVOR_SKIP_CONFIRM_LABEL,
  SURVIVOR_SKIP_CONFIRM_TITLE,
} from "./survivorGameCopy";

export type typeSkipRoundDialogProps = {
  open: boolean;
  body: string;
  isPending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function SkipRoundDialog(props: typeSkipRoundDialogProps): JSX.Element {
  return (
    <Dialog
      open={props.open}
      onOpenChange={(open) => {
        if (!open) props.onCancel();
      }}
      title={SURVIVOR_SKIP_CONFIRM_TITLE}
      autoFocus={false}
      footer={
        <>
          <Button
            variant="secondary"
            data-testid="survivor-skip-cancel"
            onClick={props.onCancel}
          >
            {SURVIVOR_SKIP_CANCEL_LABEL}
          </Button>
          <Button
            variant="primary"
            data-testid="survivor-skip-confirm"
            disabled={props.isPending}
            loading={props.isPending}
            onClick={props.onConfirm}
          >
            {SURVIVOR_SKIP_CONFIRM_LABEL}
          </Button>
        </>
      }
    >
      <p
        className="text-body text-ink"
        data-testid="survivor-skip-confirm-body"
      >
        {props.body}
      </p>
    </Dialog>
  );
}
